var _style, _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYooxLogoP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 35",
    style: {
      enableBackground: "new 0 0 77 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000010310568515009250640000008688834393269319350_);}\n\t.st1{fill:#8800BB;}\n\t.st2{fill:#0000FF;}\n\t.st3{fill:#88BBDD;}\n\t.st4{fill:#66BB44;}\n\t.st5{fill:#FFEE00;}\n\t.st6{fill:#FF4411;}\n\t.st7{fill:#FF1100;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M11.1,8.2l-0.3,1.2l-0.7,3c-0.2,0.7-0.4,2-0.7,3.8C9,14,8.4,11.7,7.7,9.5C7.6,9.2,7.5,8.9,7.5,8.7 C7.4,8.4,7.3,8.2,7.2,7.9L5,0.6H0.2l7.1,19.3v14.6h4.5V19.9l5.9-19.3h-4.8L11.1,8.2z M34.3,3c-1.4-1.9-3.5-2.9-6.3-2.9 c-3.2,0-5.4,1.3-6.7,3.8s-2,6.8-2,12.8c0,6.8,0.7,11.5,2,14.1c1.3,2.7,3.7,4.1,7,4.1c3.2,0,5.4-1.3,6.7-3.8s2-6.8,2-12.8 c0-4.3-0.2-7.5-0.6-9.7C35.9,6.2,35.2,4.4,34.3,3z M31.3,28.2c-0.5,1.7-1.6,2.5-3.2,2.5c-1.6,0-2.6-0.9-3.2-2.7 c-0.6-1.9-0.8-5.4-0.8-10.3c0-5.4,0.2-9,0.8-10.8c0.5-1.8,1.6-2.7,3.3-2.7c1.6,0,2.7,1,3.2,2.9s0.8,5.8,0.8,11.7l0,0 C32.1,23.4,31.8,26.5,31.3,28.2z M55.8,3.1c-1.4-1.9-3.5-2.9-6.3-2.9c-3.2,0-5.4,1.3-6.8,3.8s-2,6.8-2,12.8c0,6.8,0.7,11.5,2,14.1 c1.3,2.7,3.7,4.1,7,4.1c3.1,0,5.4-1.3,6.7-3.8s2-6.8,2-12.8c0-4.3-0.2-7.5-0.6-9.7C57.4,6.2,56.7,4.4,55.8,3.1z M52.7,28.2 c-0.5,1.7-1.6,2.5-3.2,2.5c-1.6,0-2.6-0.9-3.2-2.7c-0.6-1.9-0.8-5.4-0.8-10.3c0-5.4,0.2-9,0.8-10.8c0.5-1.8,1.6-2.7,3.2-2.7 c1.6,0,2.7,1,3.2,2.9s0.8,5.8,0.8,11.7l0,0C53.6,23.4,53.3,26.5,52.7,28.2z M76.8,0.6h-4.6l-2.2,7l-0.3,1 c-0.2,0.7-0.4,1.4-0.6,2.1c-0.2,0.7-0.4,1.4-0.5,2.2c-0.4-1.9-0.9-3.8-1.6-5.7l-2.3-6.6h-4.4l6,16.7l-6.4,17.2h4.8l2-6.1l0.4-1.3 l0.8-2.4c0.3-0.9,0.5-1.9,0.6-2.8c0.1,0.9,0.3,1.8,0.6,2.7c0.3,1,0.6,2.2,1.1,3.5l2.2,6.5h4.6l-6.3-17.2L76.8,0.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000171001081038126284270000017772873036256759485_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000171001081038126284270000017772873036256759485_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 0.1,
    className: "st1",
    width: 76.7,
    height: 34.7
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 5.1,
    className: "st2",
    width: 76.7,
    height: 29.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 10.1,
    className: "st3",
    width: 76.7,
    height: 24.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 15,
    className: "st4",
    width: 76.7,
    height: 19.9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 20,
    className: "st5",
    width: 76.7,
    height: 14.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 25,
    className: "st6",
    width: 76.7,
    height: 9.9
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 29.9,
    className: "st7",
    width: 76.7,
    height: 5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYooxLogoP);
export default __webpack_public_path__ + "static/media/yoox-logo-p.5755e2f333093299f1dbffc90e5174cd.svg";
export { ForwardRef as ReactComponent };